import './css/app.scss'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue-toast-notification/dist/theme-default.css';
import '@mdi/font/css/materialdesignicons.min.css';
import "flag-icons/css/flag-icons.min.css";

import {createApp} from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import en from './locales/en.json'
import pl from './locales/pl.json'
import cs from './locales/cs.json'
import es from './locales/es.json'
import ru from './locales/ru.json'
import uk from './locales/uk.json'
import { getPreferredLocale } from '@/utils/locale'

window.axios = axios;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.baseURL = import.meta.env.VITE_API_URL;
axios.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = config.overrideLanguage || getPreferredLocale();
    return config;
});

const i18n = createI18n({
    locale: getPreferredLocale(),
    fallbackLocale: 'en',
    messages: {
        en, pl, cs, es, ru, uk
    }
})

const app = createApp(App)

app.use(i18n)

import WithdrawalRequestModal from "@/components/modals/WithdrawalRequestModal.vue";
app.component("withdrawal-request-modal", WithdrawalRequestModal);

import { VueginateBulma } from 'vueginate';
app.component('pagination', VueginateBulma);

import {RouterLink, RouterView} from 'vue-router'
app.component('router-link', RouterLink);
app.component('router-view', RouterView);

import EmployeeForm from "@/components/users/EmployeeForm.vue";
app.component("employee-form", EmployeeForm);

import EmployerForm from "@/components/users/EmployerForm.vue";
app.component("employer-form", EmployerForm);

import TrainerForm from "@/components/users/TrainerForm.vue";
app.component("trainer-form", TrainerForm);

import DeleteWithConfirmation from "@/components/DeleteWithConfirmation.vue";
app.component("delete-with-confirmation", DeleteWithConfirmation);

import LoaderComponent from "@/components/Loader.vue";
app.component("loader", LoaderComponent);

import AddInvoiceModal from "@/components/modals/AddInvoiceModal.vue";
app.component("add-invoice-modal", AddInvoiceModal);

import SettleWithdrawalsModal from "@/components/modals/SettleWithdrawalsModal.vue";
app.component("settle-withdrawals-modal", SettleWithdrawalsModal);

import WithdrawalRequestsTable from "@/components/companies/WithdrawalRequestsTable.vue";
app.component("withdrawal-requests-table", WithdrawalRequestsTable);

import WithdrawalSettlementsTable from "@/components/companies/WithdrawalSettlementsTable.vue";
app.component("withdrawal-settlements-table", WithdrawalSettlementsTable);

import LightSwitch from "@/components/LightSwitch.vue";
app.component("light-switch", LightSwitch);

import VueTurnstile from 'vue-turnstile';
app.component('vue-turnstile', VueTurnstile);

app.use(router)

import Auth from './plugins/auth.js'
app.use(Auth, {router, axios, i18n});

import Modal from './plugins/modal.js'
app.use(Modal, {router});

import Buefy from 'buefy'
app.use(Buefy);

import ToastPlugin from 'vue-toast-notification';
app.use(ToastPlugin);

app.mount('#app')

window.addEventListener('offline', () => {
    app.config.globalProperties.$toast.error(i18n.global.t('messages.internet_connection_lost'));
});

window.addEventListener('online', () => {
    app.config.globalProperties.$toast.success(i18n.global.t('messages.internet_connection_restored'));
});

const getColorPreference = () => {
    if (localStorage.getItem('theme-preference'))
        return localStorage.getItem('theme-preference')
    else
        return window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light'
}
document.firstElementChild.setAttribute('data-theme', getColorPreference())
